import Controller from 'controllers/controller';
import MenuButtonController from 'controllers/menu-button';
import Elements from 'tools/elements';
import Binder from 'tools/binder';

class MenuButtonsController extends Controller {
    /**
     * Wrapper for instantiating the many layers of menu-toggle buttons.
     */
    constructor(app) {
        super(app);
        
        this.elements = new Elements;
        this.binder = new Binder(this);
        this.instances = [ ];
        
        this.cacheElements();
        this.attachEvents();
        this.initControllers();
    }
    
    cacheElements() {
        this.elements.queryOne('header', '#header');
        this.elements.queryAll('buttons', '.menu-toggle');
    }
    
    attachEvents() {
        this.app.breakpointController.on('change', this.binder.bind('onBreakpointChange'));
    }
    
    initControllers() {
        this.elements.each('buttons', button => {
            this.instances.push(new MenuButtonController(this.app, button));
        });
    }
    
    destroyControllers() {
        this.instances.forEach(instance => instance.destroy());
        
        this.instances = [ ];
    }

    onBreakpointChange() {
        this.destroyControllers();
        this.elements.updateQueries();
        this.initControllers();
    }
}

export default MenuButtonsController;